import * as React from "react";
import * as _ from "lodash";
import CarouselSlide from "../share/CarouselSlide";
import { groupDataForSlide } from "../../util/groupDataForSlide";
import { VideoGallery, HinhAnhGallery } from "../../models/HinhAnhGallery";
import { GalleryService } from "../../services";
import { DANH_MUC } from "../../const/danh-muc";
import Spinner from '../share/Spinners/Spinners'
// import ReactYoutube from "react-youtube";
import SpinnersVideo from "../share/Spinners/SpinnersVideo";
import Image from "../../components/share/Image";
import Modal from "../share/Modal";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    // width: '590px',
    background: "none",
    padding: 0,
    border: 'none',
    "border-radius": "0px",
  },
  overlay: {
    zIndex: 99,
    backgroundColor: 'rgba(2, 2, 2, 0.38)',
  },
}
export interface Props {
  isHideTitle?: boolean;
}
export interface State {

}

let count = 0;
let group = 1;
let arrayNumber = _.range(1, 17);
const slides = _.groupBy(arrayNumber, _ => {
  if (count === 4) {
    count = 0;
    group++;
  }
  count++;
  return group;
});

export default class Video extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      videoList: [],
      id: '',
      openModal: false
    };
  }

  componentDidMount() {
    GalleryService.getList(DANH_MUC.VIDEO, "v", 1, 3)
      .then(value => {
        if (value.galleries) {
          if (value.galleries.length > 0) {
            const _lala: any = value.galleries
            const _videoList: any = groupDataForSlide<VideoGallery>(_lala, 3);
            this.setState({
              loading: true,
              videoList: _videoList
            });
          } else {
            this.setState({
              loading: true,
              videoList: []
            });
          }

        }
      });
  }
  openModal(id) {
    this.setState({
      id: id,
      openModal: true
    });
  }
  closeModal() {
    this.setState({
      openModal: false
    });
  }
  modal() {
    const videoSrc = `https://www.youtube.com/embed/${this.state.id}`;

    return (
      <Modal
        isOpen={this.state.openModal}
        className="modal-video-yb"
        onRequestClose={() => this.closeModal()}
        contentLabel="Minimal Modal Example"
        style={customStyles}
        aria={{
          labelledby: 'modalTitle',
        }}
      >
        <span>
          <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="" width="100%" height="360" src={videoSrc} id="widget2" data-gtm-yt-inspected-9="true"></iframe>
        </span>
      </Modal>
    );
  }
  render() {
    let { loading, videoList } = this.state;
    let { isHideTitle } = this.props;
    return (
      <div className="container block-video">
        {this.modal()}
        {!isHideTitle && <div className="col text-center block-title">VIDEO</div>}
        {
          this.state.videoList.length == 0 ? 'Không có video' :
            this.state.loading ? (
              // <CarouselSlide
              //   id="videoCarousel"
              //   arrowNextClass="carousel-control-next-event"
              //   arrowPrevClass="carousel-control-prev-event"
              // >
              <div id="sukienCarousel456" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    {videoList.map((innerVideoList, index) => {
                      return (
                        <div key={index} className="row col">
                          {innerVideoList.map(video => {
                            var id
                            if (video.data.id.indexOf('&') == -1) {
                              id = video.data.id
                            } else {
                              id = video.data.id.substring(0, video.data.id.indexOf('&'))
                            }
                            return (
                              <div key={video.gallery_id} className="col-md-4" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                <div className="div-video-yb" onClick={() => this.openModal(id)}
                                  style={{ backgroundImage: "url(" + video.hinh_dai_dien + ")" }}
                                >
                                  {/* <Image
                              key={index}
                              className="d-block w-100 hand"
                              src={video.hinh_dai_dien}
                              alt={video.tieu_de}
                              classPlaceHolder={'lazy-image-slide'} /> */}
                                  <div className="btn-play-yb">
                                    <div className='icon-play'></div>
                                  </div>
                                </div>
                                <div className="title-video text-center trimtext back-yellow" style={{ color: "#2E3191" }}>
                                  <b>{video.tieu_de}</b>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              // </CarouselSlide>
            ) : <SpinnersVideo type={'placeholde'} loading={true} />
        }
      </div>
    );
  }

}
